import React, { Component } from 'react';
import axios from 'axios';
import $ from 'jquery';

import LoadingScreen from '../../../Ui/LoadingScreen/LoadingScreen';

import classes from './IAndCLifecycleMonitor.module.css';
import { pushToError } from '../../../../utils/common';
class IAndCLifecycleMonitor extends Component {
  state = {
    htmlApiLoading: true,
  };
  componentDidMount() {
    this.props.setCurrentRouteState('hl/monitor', 'I&C Lifecycle');
    if (!this.props.userfleetApiLoading) {
      $('.' + classes.IAndCLifecycleMonitor).load(
        '/html/angularContainer.html',
        () => {
          const url = `${this.props.settings.server}hl/hl.static/html/obs_dashboard.html`;
          axios
            .get(url, {
              headers: { Authorization: `Bearer ${this.props.settings.token}` },
            })
            .then(response => {
              $('#angularContainer').load(window.makeTextFile(response.data));
              this.setState({
                htmlApiLoading: false
              });
            })
            .catch(err => {
              console.error(err);
              pushToError(this.props,this.state.pname,err,url);
            });
        }
      );
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.userfleetApiLoading !== this.props.userfleetApiLoading) {
      this.setState({
        htmlApiLoading: true,
      });
      $('.' + classes.IAndCLifecycleMonitor).load(
        '/html/angularContainer.html',
        () => {
          const url = `${this.props.settings.server}hl/hl.static/html/obs_dashboard.html`;
          axios
            .get(url, {
              headers: { Authorization: `Bearer ${this.props.settings.token}` },
            })
            .then((response) => {
              $('#angularContainer').load(window.makeTextFile(response.data));
              this.setState({
                htmlApiLoading: false,
              });
            })
            .catch((err) => {
              console.error(err);
              pushToError(this.props,this.state.pname,err,url);
            });
        }
      );
    }
  }
  render() {
    return (
      <React.Fragment>
        {this.state.htmlApiLoading || this.props.userfleetApiLoading ? (
          <LoadingScreen />
        ) : null}
        <div className={classes.IAndCLifecycleMonitor}>Lifecycle Monitor</div>
      </React.Fragment>
    );
  }
}

export default IAndCLifecycleMonitor;
